// navy 020c1b
//
//      const variables = css`
//        :root {
//          --dark-navy: #020c1b;
//          --navy: #0a192f; Main background
//          --light-navy: #112240;
//          --lightest-navy: #233554;
//          --navy-shadow: rgba(2, 12, 27, 0.7); # shadow over nav bar and under picture
//          --dark-slate: #495670; / side scroll
//          --slate: #8892b0; # 2nd hex color
//          --light-slate: #a8b2d1;
//          --lightest-slate: #ccd6f6;
//          --white: #e6f1ff;
//          --white-new: #64ffda;
//          --white-new-tint: rgba(100, 255, 218, 0.1);
//          --pink: #f57dff;
//          --blue: #57cbff;
//          --black: rgb(15 23 42 / 1);
//          --black-light: rgb(23 23 23 / 1);
//          --pure-white: #fff;
//          --white-new: #F3F3E0;
//
//          --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
//            sans-serif;
//          --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;
//
//          --fz-xxs: 12px;
//          --fz-xs: 13px;
//          --fz-sm: 14px;
//          --fz-md: 16px;
//          --fz-lg: 18px;
//          --fz-xl: 20px;
//          --fz-xxl: 22px;
//          --fz-heading: 32px;
//
//          --border-radius: 4px;
//          --nav-height: 100px;
//          --nav-scroll-height: 70px;
//
//          --tab-height: 42px;
//          --tab-width: 120px;
//
//          --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
//          --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
//
//          --hamburger-width: 30px;
//
//          --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
//          --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
//          --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
//          --ham-after-active: bottom 0.1s ease-out,
//            transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
//        }
//      `;
//
//      export default variables;
import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #020c1b;
    --navy: #0a192f;
    --light-navy: #112240;
    --lightest-navy: #233554;
    --navy-shadow: rgba(27, 25, 2, 0.7);
    --dark-slate: #495670;
    --slate: #8892b0;
    --light-slate: #a8b2d1;
    --lightest-slate: #d6defaff;
    --white: #e6f1ff;
    --white-new: #64ffda;
    --white-new-tint: rgba(100, 255, 218, 0.1);
    --green: #64ffda;
    --green-tint: rgba(100, 255, 218, 0.1);
    --pink: #f57dff;
    --blue: #57cbff;
    --black: rgb(15 23 42 / 1);
    --black-light: rgb(23 23 23 / 1);
    --pure-white: #fff;
    --white-new: #e8f2ffff;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    /* Responsive font sizes */
    --fz-heading-large: clamp(40px, 8vw, 80px);
    --fz-heading-medium: clamp(24px, 5vw, 48px);
    --fz-heading-small: clamp(20px, 4vw, 32px);
    --fz-body-large: clamp(16px, 2vw, 18px);
    --fz-body-medium: clamp(14px, 1.8vw, 16px);
    --fz-body-small: clamp(12px, 1.5vw, 14px);

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    /* Responsive spacing */
    --section-padding: clamp(60px, 12vw, 120px);
    --container-padding: clamp(25px, 5vw, 50px);
    --grid-gap-small: clamp(15px, 2vw, 20px);
    --grid-gap-medium: clamp(20px, 3vw, 30px);
    --grid-gap-large: clamp(30px, 5vw, 50px);

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    --smooth-transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    --bounce-easing: cubic-bezier(0.68, -0.55, 0.265, 1.55);
    --spring-easing: cubic-bezier(0.34, 1.56, 0.64, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
